<div class = "dialog-header-container">
  <h2 mat-dialog-title class="mar-b-5 pd-t-5px">Create Templates</h2>
  <div> 
    <button mat-icon-button mat-dialog-close>
      <mat-icon>
        close
      </mat-icon>
    </button>
  </div>
</div>
<div class="loading-indicator">
  <mat-progress-spinner mode="indeterminate"  *ngIf="isLoading" bdColor="rgba(51,51,51,0.8)" diameter='25' strokeWidth='3'></mat-progress-spinner>
</div>
<mat-divider class="mat-divider"></mat-divider>
<form class="example-form" [formGroup]="templateForm" (ngSubmit)="saveMeetingTemplate()" [hidden]="isLoading">
  <div mat-dialog-content class="dialog-with-actions">
    <mat-form-field class="example-full-width w-100 mt-10" >
      <mat-label>Template Name <span class="asterik-class">&nbsp;*</span></mat-label>
      <input matInput value="" formControlName="templateName">
      <mat-error *ngIf="isSubmitted && formControls.templateName.errors && formControls.templateName.errors.required">Template Name is required</mat-error>
    </mat-form-field>
    <!-- <div *ngIf="isSubmitted && formControls.templateName.errors" class="help-block">
      <div *ngIf="formControls.templateName.errors.required" class="validateFont">Template Name is required</div>
    </div> -->
    <mat-form-field class="w-100" [attr.disabled]="true" id = "category-selectone-field">
        <mat-label id = "category-selectone" >Select Category <span class="asterik-class">&nbsp;*</span></mat-label>
        <mat-select [(ngModel)]="selected" disableOptionCentering panelClass="common-drop-down-class" formControlName="categoryStates" id = "category-select" >
          <mat-option  *ngFor="let state of categoryType" [value]="state.codeId">{{state.description}}</mat-option>
        </mat-select>
        <mat-error *ngIf="categoryError && isSubmitted && formControls.categoryStates.errors && formControls.categoryStates.errors.required">Please Select Category</mat-error>
    </mat-form-field>
    <!-- <div *ngIf="categoryError && isSubmitted && formControls.categoryStates.errors" class="help-block">
        <div *ngIf="formControls.categoryStates.errors.required" class="validateFont">Please Select Category</div>
    </div> -->
    <div mat-dialog-actions class="d-flex justify-content-end">
        <mat-form-field  *ngIf = "categoryShow" id="tempCreate" class="example-full-width w-100 mt-1 creatTempl">
            <mat-label>Category Name<span class="asterik-class">&nbsp;*</span></mat-label>
            <input matInput value="" formControlName="categoryName">
            <!-- <div *ngIf="categoryShow && isSubmitted && formControls.categoryName.errors">               -->
              <mat-error *ngIf="categoryShow && isSubmitted && formControls.categoryName.errors && formControls.categoryName.errors.required">Category Name is required</mat-error>
            <!-- </div> -->
          </mat-form-field>
          <!-- <div *ngIf="categoryShow && isSubmitted && formControls.categoryName.errors" class="category-block">
            <div *ngIf="formControls.categoryName.errors.required" class="validateFont">Category Name is required</div>
          </div> -->
            <button [attr.disabled]="true" id = "category-btn" class="button-container primary" type="button" mat-flat-button  (click)="isopenCategory(categoryName)">
                Add Category
            </button>              
    </div>
    <mat-form-field class="example-full-width w-100"> 
        <mat-label>Template Description</mat-label>
        <textarea matInput placeholder="" formControlName="templateDesc"></textarea>
    </mat-form-field>
      <!-- <div *ngIf="isSubmitted && formControls.templateDesc.errors" class="help-block">
        <div *ngIf="formControls.templateDesc.errors.required" class="validateFont">Template Description is required</div>
      </div> -->
    <div>
        <div [ngStyle]="{'margin-bottom':'10px'}">
           <mat-checkbox class="example-margin" formControlName="participants">Include Attendee(s)</mat-checkbox>
        </div>
        <!-- <div [ngStyle]="{'margin-bottom':'10px'}">
           <mat-checkbox class="example-margin" formControlName="notes">Include Notes</mat-checkbox>
        </div> -->
    </div>
  </div>
  <div mat-dialog-actions class="d-flex justify-content-end">
    <!-- <span><button class="button-container primary" type="button" mat-flat-button color="primary" (click)="cancelMeeting()">Save</button></span>&nbsp;&nbsp;
    <span> (click)="saveMeetingTemplate(templateForm.value)"-->
        <button class="button-container primary" type="submit" mat-flat-button color="primary">
            SAVE
        </button>
        <button type="button" #editModalClose mat-flat-button color="primary" class="button-container primary" mat-dialog-close>
            CANCEL
        </button>
  </div>
</form>


